import React from "react";
import { Link } from "react-router-dom";
import { jobCatalog } from "../data/jobs";
import Icon from "./Icon";

export default function JobHeader({ jobId }) {
    const job = jobCatalog.find((item) => item.id === jobId);
    return (
        <section className="job-header">
            <div className="site-container">
                <Link to="/#vacatures" className="back-link">
                    <Icon /> Alle vacatures
                </Link>
                <span className="eyebrow">JOUW TOEKOMST BIJ SMITH</span>
                <h1>{job.title}</h1>
                <div className="job-header-bottom">
                    <div className="job-meta">
                        <span>
                            <Icon name="pin" />
                            {job.location}
                        </span>
                        <span>
                            <Icon name="clock" />
                            {job.hours}
                        </span>
                        <span>
                            <Icon name="education" />
                            {job.education}
                        </span>
                    </div>
                    <a
                        className="button button-orange"
                        href={`mailto:hr@smithtechniek.nl?subject=${encodeURIComponent(`Sollicitatie ${job.title}`)}`}
                    >
                        Solliciteer direct <Icon />
                    </a>
                </div>
            </div>
        </section>
    );
}
